"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/checkbox/checkbox-checked-context.tsx
var _react = require('react');
var CheckboxCheckedContext = _react.createContext.call(void 0, false);



exports.CheckboxCheckedContext = CheckboxCheckedContext;
